import React, { useEffect, useState } from "react";
import classes from "../style/Style.module.css";
import "../style/Infoscreens.scss";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import {
  ROUTE_CHECKBOXES,
  ROUTE_NOMINEE_GUARDIAN,
  ROUTE_EMAIL,
  ROUTE_ACCOUNT_TYPE,
  Address_Verification,
  ROUTE_OCCUPATION,
  ROUTE_PLACEOF_BIRTH,
  ROUTE_UPDATED_PORT_FOLIO_SCREEN,
  Gender_Dob_Verification,
  ROUTE_NOMINEE_SENDOTP,
  ROUTE_MOBILE_VERIFICATION,
  ROUTE_DXTER_SCANNING, ROUTE_NRI_Address
} from "../Routes";
import { useNavigate } from "react-router-dom";
import { isValid, isBefore, parse, isSameDay, isAfter } from "date-fns";
import { ToastContainer } from "react-toastify";
import Toast from "../Components/ToastMsg/Toast";
import axios from "../libs/axiosConfig";
import { useDispatch, useSelector } from "react-redux";
import { selectPhoneNumber } from "../Store/MobileSlice";
import { selectPanNumber } from "../Store/panNumberSlice";
import { selectRefreshToken } from "../Store/Token/refreshTokenSlice";
import { setBankName } from "../Store/UserBankSlice";
import NewDexterLogo from "../Images/NewDexterLogo.svg";
import LogoutModal from "../Components/LogoutModal";
import CalendarMonthOutlinedIcon from "@mui/icons-material/CalendarMonthOutlined";
import Calendar from "react-calendar";
import "react-calendar/dist/Calendar.css";
import "../style/Calender.css";


const NomineeDetails = () => {
  const Navigate = useNavigate();
  const storedToken = useSelector((state) => state.storedToken.accessToken);
  const [nomineeAge, setNomineeAge] = useState(0);
  const [formErrors, setFormErrors] = useState({});
  const [nomineeName, setnomineeName] = useState("");
  const [nomineeDob, setNomineeDob] = useState("");
  const [nomineeRelation, setnomineeRelation] = useState("");
  const [suggestions, setSuggestions] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [isValidDob, setIsValidDob] = useState(true);
  const phoneNumber = useSelector(selectPhoneNumber);
  const panNumber = useSelector(selectPanNumber);
  const refreshToken = useSelector(selectRefreshToken);
  const dispatch = useDispatch();
  const [showModal, setShowModal] = useState(false);
  const [apiCallsInProgress, setApiCallsInProgress] = useState(0);


  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (apiCallsInProgress > 0) {
      setIsLoading(true);
    } else {
      setIsLoading(false);
    }
  }, [apiCallsInProgress]);

  const nomineeRelationOptions = [
    "Father",
    "Mother",
    "Wife",
    "Husband",
    "Son",
    "Daughter",
    "Father-in-law",
    "Mother-in-law",
    "Son-in-law",
    "Daughter-in-law",
    "Aunt",
    "Uncle",
    "Niece",
    "Nephew",
    "Brother",
    "Sister",
    "Grand Father",
    "Grand Mother",
    "Others",
  ];


  const [showCalendar, setShowCalendar] = useState(false);
  const [selectedDate, setSelectedDate] = useState(new Date());

  const handleClick = () => {
    setShowCalendar(!showCalendar);
  };

  const handleDateChange = (date) => {
    const currentDate = new Date();
    const minDate = parse("1925-01-01", "yyyy-MM-dd", new Date());
    const maxDate = currentDate;

    if (isValid(date) && !isAfter(date, maxDate)) {
      setSelectedDate(date);
      setShowCalendar(false);

      const formattedDate = `${date.getDate().toString().padStart(2, "0")}-${(
        date.getMonth() + 1
      )
        .toString()
        .padStart(2, "0")}-${date.getFullYear()}`;
      setNomineeDob(formattedDate);
      console.log(formattedDate);
    } else {
      console.error("Selected date is out of range");
    }
  };

  const handlenomineeNameChange = (e) => {
    const input = e.target.value;

    const alphabetsOnly = /^[A-Za-z\s]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setnomineeName(input);
    }
  };

  const validateDob = (dob) => {
    const currentDate = new Date();
    const parsedDob = parse(dob, "dd-MM-yyyy", new Date());

    const isDateValid =
      isValid(parsedDob) &&
      isBefore(parsedDob, currentDate) &&
      !isSameDay(parsedDob, currentDate);
    const isDayValid = parsedDob.getDate() <= 31;
    const isMonthValid = parsedDob.getMonth() + 1 <= 12;
    const isYearValid =
      parsedDob.getFullYear() >= 1925 &&
      parsedDob.getFullYear() <= currentDate.getFullYear();

    return isDateValid && isDayValid && isMonthValid && isYearValid;
  };

  const handlenomineeDobChange = (e) => {
    let input = e.target.value.replace(/\D/g, "");
    let formattedInput = input
      .replace(/^(\d{2})(\d{0,2})/, "$1-$2")
      .replace(/^(\d{2})-(\d{2})(\d{0,4})/, "$1-$2-$3");

    if (formattedInput.length > 0) {
      const yearPart = formattedInput.split("-")[2];
      if (yearPart && yearPart.length > 4) {
        formattedInput = formattedInput.slice(0, -1);
      }
    }

    const [day, month, year] = formattedInput.split("-").map(Number);

    if (day > 31) {
      formattedInput = formattedInput.slice(0, -1);
    }

    if (month > 12) {
      formattedInput = formattedInput.slice(0, -1);
    }

    const currentYear = new Date().getFullYear();

    if (year < 1925 || year > currentYear) {
      setFormErrors({ DOB: "Please enter a valid year" });
    } else {
      setFormErrors({ DOB: "" });
    }

    if (year > currentYear || (year === currentYear && month > new Date().getMonth() + 1) || (year === currentYear && month === new Date().getMonth() + 1 && day > new Date().getDate())) {
      const currentDate = new Date();
      formattedInput = `${currentDate.getDate().toString().padStart(2, "0")}-${(currentDate.getMonth() + 1).toString().padStart(2, "0")}-${currentDate.getFullYear()}`;
    }

    setNomineeDob(formattedInput);
    setIsValidDob(validateDob(formattedInput));

    const parsedDob = parse(formattedInput, "dd-MM-yyyy", new Date());
    const currentDate = new Date();
    let age = currentDate.getFullYear() - parsedDob.getFullYear();

    if (
      currentDate.getMonth() < parsedDob.getMonth() ||
      (currentDate.getMonth() === parsedDob.getMonth() &&
        currentDate.getDate() < parsedDob.getDate())
    ) {
      age--;
    }
    setNomineeAge(age);
  };

  const handleBackspace = (e) => {
    const input = e.target.value.replace(/\D/g, "");
    let formattedInput = "";

    if (input.length > 2) {
      formattedInput = input.slice(0, 2) + "-" + input.slice(2, 4);
      if (input.length > 4) {
        formattedInput += "-" + input.slice(4, 8);
      }
    } else {
      formattedInput = input;
    }

    setNomineeDob(formattedInput);
  };

  const handlenomineeRelationChange = (e) => {
    const input = e.target.value;
    const alphabetsOnly = /^[A-Za-z\s]+$/;

    if (alphabetsOnly.test(input) || input === "") {
      setnomineeRelation(input);

      const filteredSuggestions = nomineeRelationOptions.filter(
        (item) =>
          item.toLowerCase().startsWith(input.toLowerCase()) &&
          item.toLowerCase() !== input.toLowerCase()
      );

      setSuggestions(filteredSuggestions);
      setShowSuggestions(true);
    }
  };

  const handlenomineeNameClear = () => {
    setnomineeName("");
  };

  const handlenomineeDobClear = () => {
    setNomineeDob("");
  };

  const handlenomineeRelationShow = () => {
    const filteredSuggestions = nomineeRelationOptions.filter(
      (item) =>
        item.toLowerCase().startsWith(nomineeRelation.toLowerCase()) &&
        item.toLowerCase() !== nomineeRelation.toLowerCase()
    );

    setSuggestions(filteredSuggestions);
    setShowSuggestions((prevShowSuggestions) => !prevShowSuggestions);
  };

  const handleSuggestionClick = (selectedRelation) => {
    setnomineeRelation(selectedRelation);
    setSuggestions([]);
    setShowSuggestions(false);
  };

  const HandleBack = () => {
    setShowModal(true);
  };

  const handleLogoutConfirm = () => {
    Navigate(ROUTE_MOBILE_VERIFICATION);
  };

  const HandleSubmit = async () => {
    setApiCallsInProgress(apiCallsInProgress + 1);

    if (!nomineeName || !nomineeDob || !nomineeRelation) {
      Toast.error("Please fill all the required details.");
      setApiCallsInProgress(apiCallsInProgress - 1);

      return;
    }
    const parsedDate = parse(nomineeDob, "dd-MM-yyyy", new Date());
    if (parsedDate.getFullYear() < 1925) {
      Toast.error("Please fill valid date.");
      setApiCallsInProgress(apiCallsInProgress - 1);

      return;
    }

    const currentDate = new Date();
    let age = currentDate.getFullYear() - parsedDate.getFullYear();
    if (
      currentDate.getMonth() < parsedDate.getMonth() ||
      (currentDate.getMonth() === parsedDate.getMonth() &&
        currentDate.getDate() < parsedDate.getDate())
    ) {
      age--;
    }
    const isValidDob = validateDob(nomineeDob);
    let nomineeType = isValidDob && nomineeAge < 18 ? "Y" : "N";
    const formattedNomineeDob = nomineeDob
      ? `${nomineeDob.slice(6)}-${nomineeDob.slice(3, 5)}-${nomineeDob.slice(
        0,
        2
      )}`
      : "";
    console.log(nomineeType)
    console.log(nomineeAge)
    console.log(formattedNomineeDob)
    if (isValidDob) {
      if (nomineeAge < 18) {
        nomineeType = "Y";
        Navigate(ROUTE_NOMINEE_GUARDIAN, {
          state: {
            nomineeAllocationPercentage: "100",
            nomineeName: nomineeName,
            nomineeRelationShip: nomineeRelation,
            nomineeDob: formattedNomineeDob,
            nomineeType: nomineeType,
          },
        });
        return;
      } else {
        Navigate(ROUTE_NOMINEE_SENDOTP);
      }
    } else {
      Toast.error("Invalid Date of Birth");
      return;
    }

    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };
      const dexterrResponse = await axios.post(
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc",
        {
          CustomerKycDetails: {
            request_type: "post",
            mobileNumber: phoneNumber,
            pan: panNumber,
            nomineeAllocationPercentage: "100",
            nomineeName: nomineeName,
            nomineeRelationShip: nomineeRelation,
            nomineeDob: formattedNomineeDob,
            nomineeType: nomineeType,
            nomineeGuardianName: "",
            nomineeGuardianPan: "",
          },
        },
        {
          headers: {
            Authorization: `Bearer ${storedToken}`,
            // RefreshToken: refreshToken
          },
        }
      );

      if (dexterrResponse.data.statusCode === 200) {
        // Toast.success("Dexterr API call successful", "success");
        setApiCallsInProgress(apiCallsInProgress - 1);

        // const secondApiResponse = await axios.post(
        //   "https://partnerapp.ambrela.money/api/AddCustomerKycDetails",
        //   {
        //     nomineeAllocationPercentage: "100",
        //     nomineeName: nomineeName,
        //     nomineeRelationShip: nomineeRelation,
        //     nomineeDob: formattedNomineeDob,
        //     nomineeType: nomineeType,
        //     nomineeGuardianName: "",
        //     nomineeGuardianPan: "",
        //   },
        //   {
        //     headers: {
        //       Authorization: `Bearer ${storedToken}`,
        //       // RefreshToken: refreshToken
        //     },
        //   }
        // );


        // Toast.success("Second API call successful", "success");
        setApiCallsInProgress(apiCallsInProgress - 1);


      } else {
        console.error("First API call failed");
        Toast.error(
          dexterrResponse.data.message + " " + dexterrResponse.data.errorMessage
        );
        setApiCallsInProgress(apiCallsInProgress - 1);

      }
    } catch (error) {
      // console.error("Error in API calls:", error);
      // console.error("API Response:", error.response);
      Toast.error(
        error.response.data.errorMessage + " " + error.response.data.message ||
        "Error"
      );
    }
  };
  const HandleSkip = async () => {
    try {
      const headers = {
        Authorization: `Bearer ${storedToken}`,
        // RefreshToken: refreshToken
      };

      // First API call
      const thirdapi =
        "https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc";
      const thirdRequestBody = {
        CustomerKycDetails: {
          request_type: "get",
          country_code: "+91",
          mobileNumber: phoneNumber,
          pan: panNumber
        },
      };

      const thirdResponse = await axios.post(thirdapi, thirdRequestBody, {
        headers,
      });

      // const customerKycApiResponse = await axios.get(
      //   "https://partnerapp.ambrela.money/api/GetCustomerKycDetails",

      //   {
      //     headers: {
      //       Authorization: `Bearer ${storedToken}`,
      //       // RefreshToken: refreshToken,
      //     },
      //   }
      // );
      dispatch(
        setBankName({ bankName: thirdResponse.data.body.bankName })
      );

      if (
        thirdResponse.data.statusCode === 200 &&
        thirdResponse.data.status === true

      ) {
        const { bankVerified } = thirdResponse.data.body;

        if (
          thirdResponse.data.body.emailId === ""

        ) {
          Navigate(ROUTE_EMAIL);
          setApiCallsInProgress(apiCallsInProgress - 1);

        } else if (
          thirdResponse.data.body.bankAccountNumber === "" ||

          thirdResponse.data.body.bankIfscCode === "" ||

          thirdResponse.data.body.bankAccountType === "" ||

          thirdResponse.data.body.bankName === "" ||

          thirdResponse.data.body.bankBranchName === "" ||

          thirdResponse.data.body.bankBranchAddress === "" ||

          thirdResponse.data.body.bankCodeNSE === "" ||

          thirdResponse.data.body.bankCodeBillDesk === "" ||

          thirdResponse.data.body.bankAccountHolderName === ""

        ) {
          Navigate(ROUTE_ACCOUNT_TYPE);
          setApiCallsInProgress(apiCallsInProgress - 1);

        } else if ((thirdResponse.data.body.bankAccountNumber !== "" ||
          thirdResponse.data.body.bankIfscCode !== "" ||
          thirdResponse.data.body.bankAccountType !== "" ||
          thirdResponse.data.body.bankName !== "" ||
          thirdResponse.data.body.bankBranchName !== "" ||
          thirdResponse.data.body.bankBranchAddress !== "" ||
          thirdResponse.data.body.bankCodeNSE !== "" ||
          thirdResponse.data.body.bankCodeBillDesk !== "" ||
          thirdResponse.data.body.bankAccountHolderName !== "")
          &&
          (thirdResponse.data.body.bankVerified.account_exists !== "True" || thirdResponse.data.body.bankVerified.message !== "success")
        ) {
          Navigate(ROUTE_ACCOUNT_TYPE)
          setApiCallsInProgress(apiCallsInProgress - 1);

        } else if (
          thirdResponse.data.body.panDetails.gender === "" ||

          thirdResponse.data.body.panDetails.title === "" ||

          thirdResponse.data.body.panDetails.dob === ""
        ) {
          Navigate(Gender_Dob_Verification);
          setApiCallsInProgress(apiCallsInProgress - 1);

        } else if (
          thirdResponse.data.body.panDetails.addr1 === "" ||

          thirdResponse.data.body.panDetails.addr2 === "" ||

          thirdResponse.data.body.panDetails.city === "" ||

          thirdResponse.data.body.panDetails.state === "" ||

          thirdResponse.data.body.panDetails.pincode === "" ||

          thirdResponse.data.body.panDetails.country === "" ||

          thirdResponse.data.body.panDetails.fullAddress === ""
        ) {
          Navigate(Address_Verification);
          setApiCallsInProgress(apiCallsInProgress - 1);

        } else if (
          thirdResponse.data.body.nseIncomeCode === "" ||

          thirdResponse.data.body.nseIncomeCodeDescription === "" ||

          thirdResponse.data.body.nseOccupationCode === "" ||

          thirdResponse.data.body.nseOccupationCodeDescription === ""

        ) {
          Navigate(ROUTE_OCCUPATION);
          setApiCallsInProgress(apiCallsInProgress - 1);

        } else if (
          thirdResponse.data.body.placeOfBirth === "" ||

          thirdResponse.data.body.nseCountryCodeOfBirth === "" ||

          thirdResponse.data.body.nseCountryOfBirth === ""
        ) {
          Navigate(ROUTE_PLACEOF_BIRTH);
          setApiCallsInProgress(apiCallsInProgress - 1);

        } else if (
          thirdResponse.data.body.politicallyExposedPerson === "" ||

          thirdResponse.data.body.relatedToPoliticallyExposedPerson === ""

        ) {
          Navigate(ROUTE_CHECKBOXES);
          setApiCallsInProgress(apiCallsInProgress - 1);

        }
        else {
          const requestBody = {
            dexterrCustomerBasicQuestions: {
              mobile_no: phoneNumber,
              request_type: "get",
              country_code: "+91",
            }
          };
          const headers = {
            Authorization: `Bearer ${storedToken}`,
            // RefreshToken: refreshToken
          };

          const secondApiResponse = await axios.post("https://ylpqxjil33.execute-api.ap-south-1.amazonaws.com/pythonlambdaapistage/Python311LambdaFunc", requestBody, {
            headers: headers
          });
          if (secondApiResponse.data.data.resident !== "Resident Indian") {
            Navigate(ROUTE_NRI_Address)
          }
          else {
            Navigate(ROUTE_DXTER_SCANNING)
          }


        }

        setApiCallsInProgress(apiCallsInProgress - 1);


      }
    } catch (error) {
      console.error("Error in API calls:", error);
      console.error("API Response:", error.response);
      Toast.error("Error", "error");
    }
  };

  return (
    <div className="Nominee_details_Main_Container">
      <div className="nominee_details_Header">
        <ArrowBackIosIcon className="Back_btn" onClick={HandleBack} />
        <div className="Dexter_logo_container">
          <img alt="" src={NewDexterLogo} className="DexterLogo" />
        </div>
      </div>
      <div className="nominee_details_Div_Container">
        <p className="Input_Heading_text">Nominee details</p>
        <span className="Input_Sub_heading">
          Adding a nominee ensures a seamless transfer <br />
          for your beneficiaries.
        </span>

        {/* Nominee Name Input */}
        <div className="nominee_details_Input_Filed_Box">
          <span className="Enter_nominee_details_text">Enter nominee name</span>
          <div className="Input_Inner_Container">
            <input
              className={`${classes.Input_Filed} ${formErrors.bankAccountNumber ? classes.Error : ""
                }`}
              value={nomineeName}
              onChange={handlenomineeNameChange}
            />
            <button
              className={classes.Cross_button}
              onClick={handlenomineeNameClear}
            />
          </div>
        </div>

        {/* Nominee Date of Birth Input */}
        <div className="nominee_details_Input_Filed_Box2">
          <span className="Enter_nominee_details_text2">
            Enter nominee date of birth
          </span>
          <div className="Input_Inner_Container2">
            <input
              className={`${classes.Input_Filed} ${formErrors.ifscCode ? classes.Error : ""
                }`}
              value={nomineeDob}
              placeholder="DD-MM-YYYY"
              onChange={handlenomineeDobChange}
              onKeyDown={(e) => {
                if (e.key === "Backspace") {
                  handleBackspace(e);
                }
              }}
            />
            <CalendarMonthOutlinedIcon
              onClick={handleClick}
               value={nomineeDob}
              className={classes.Calendar_Icon}
            />
          </div>
        </div>
        {showCalendar && (
          <div className={classes.Calendar_Container}>
            <Calendar
              onChange={handleDateChange}
              value={selectedDate}
              className="custom-calendar-style"
            />
          </div>
        )}

        {/* Nominee Relation Input with Suggestions */}
        <div className="nominee_details_Input_Filed_Box3">
          <span className="Enter_nominee_details_text3">
            Enter nominee relation
          </span>
          <div className="Input_Inner_Container3">
            <input
              className={`${classes.Input_Filed} ${formErrors.ifscCode ? classes.Error : ""
                }`}
              value={nomineeRelation}
              onChange={handlenomineeRelationChange}
              onBlur={() => setShowSuggestions(true)}
            />

            <button
              className={classes.DropDown_button}
              onClick={handlenomineeRelationShow}
            />
          </div>
          {showSuggestions && (
            <div className={classes.Suggestions_Container}>
              {suggestions.map((suggestion, index) => (
                <div
                  key={index}
                  className={classes.Suggest_Suggestion}
                  onClick={() => handleSuggestionClick(suggestion)}
                >
                  {suggestion}
                </div>
              ))}
            </div>
          )}
        </div>
        <div className="NomineeDetails_Buttons_Container">
          <button className="Submit_button" onClick={HandleSubmit}>
            {" "}
            Submit{" "}
          </button>
          <button className="Skip_button" onClick={HandleSkip}>
            Skip
          </button>
        </div>
      </div>
      {isLoading && (
        <div className={classes.overlay}>
          <div className={classes.loading_text}>Please Wait...</div>
        </div>
      )}
      <ToastContainer />
      <LogoutModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onConfirm={handleLogoutConfirm}
      />
    </div>
  );
};

export default NomineeDetails;
